export default __webpack_public_path__ + "locales/az/InviteDialog.json?hash=e9b49d21b920c577714266a807d6623a";